import iconv from 'iconv-lite';
import moment from 'moment';

export const downloadText = async ({
  content,
  filename,
  selectedEncoding,
}: {
  content: string;
  selectedEncoding: string;
  filename: string;
}): Promise<void> => {
  const encodedContent = iconv.encode(content, selectedEncoding);
  const blob = new Blob([encodedContent as any], {
    type: `text/csv;charset=${selectedEncoding};`,
  });
  const now = new Date();
  const timestamp = moment(now).format('YYYYMMDDHHmmss');

  const link = document.createElement('a');
  if (link.download !== undefined) {
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', `${timestamp}_${filename}.csv`);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } else {
    alert(
      `Your browser does not support the download attribute or the file may be too large to download.`
    );
  }
};
